import { MDBBtn, MDBContainer } from "mdb-react-ui-kit";
import React, { useContext,useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchMainPageData } from "../utils/Common";
import { NavbarContext } from "../context/NavProvider";
import { MiscContext } from "../context/MiscProvider";

 function NoOrders () {
  const { isPricing,setIsPricing,pageData,setPageData} = useContext(NavbarContext);
  useEffect(() => {
    if (!pageData) {
      fetchMainPageData(setPageData,setIsPricing,pageData);
      
    }
  }, []);
  return (

  <MDBContainer className="mb-2 position-relative  justify-content-center text-center">

<section className="my-5 text-center">
          <h2 className="display-1">NO ORDERS YET</h2>

          <h4 className="mb-4">GO TO SHOP</h4>

         
          <Link to="/products">
            <MDBBtn>SHOP</MDBBtn>
       </Link>
       </section>
  </MDBContainer>
  
);
}
export default NoOrders;
